module.exports = __webpack_public_path__ + "img/product-3.4b8aa987.jpeg";